{
  "Definition": {
    "child": true,
    "requireChild": true,
    "tagGroup": true,
    "topLevelTagGroup": true,
    "maxNumberSubgroups": 1,
    "minNumberSubgroups": 0,
    "ERROR_CODE": "DEFINITION_INVALID",
    "subgroupTagsNotAllowed": [
      "Def",
      "Def-expand",
      "Event-context",
      "Definition",
      "Onset",
      "Inset",
      "Offset",
      "Delay",
      "Duration"
    ],
    "defTagRequired": false,
    "otherAllowedTags": []
  },
  "Def": {
    "child": true,
    "tagGroup": false,
    "topLevelTagGroup": false,
    "maxNumberSubgroups": null,
    "minNumberSubgroups": null,
    "ERROR_CODE": "DEF_INVALID",
    "subgroupTagsNotAllowed": [],
    "defTagRequired": false,
    "otherAllowedTags": null
  },
  "Def-expand": {
    "child": true,
    "tagGroup": true,
    "topLevelTagGroup": false,
    "maxNumberSubgroups": 1,
    "minNumberSubgroups": 0,
    "ERROR_CODE": "DEF_EXPAND_INVALID",
    "subgroupTagsNotAllowed": [
      "Def",
      "Def-expand",
      "Event-context",
      "Definition",
      "Onset",
      "Inset",
      "Offset",
      "Delay",
      "Duration"
    ],
    "defTagRequired": false,
    "otherAllowedTags": []
  },
  "Onset": {
    "child": false,
    "tagGroup": true,
    "topLevelTagGroup": true,
    "maxNumberSubgroups": 1,
    "minNumberSubgroups": 0,
    "ERROR_CODE": "TEMPORAL_TAG_ERROR",
    "subgroupTagsNotAllowed": ["Event-context", "Definition", "Onset", "Inset", "Offset", "Delay", "Duration"],
    "defTagRequired": true,
    "otherAllowedTags": []
  },
  "Inset": {
    "child": false,
    "tagGroup": true,
    "topLevelTagGroup": true,
    "maxNumberSubgroups": 1,
    "minNumberSubgroups": 0,
    "ERROR_CODE": "TEMPORAL_TAG_ERROR",
    "subgroupTagsNotAllowed": ["Event-context", "Definition", "Onset", "Inset", "Offset", "Delay", "Duration"],
    "defTagRequired": true,
    "otherAllowedTags": []
  },
  "Offset": {
    "child": false,
    "tagGroup": true,
    "topLevelTagGroup": true,
    "maxNumberSubgroups": 0,
    "minNumberSubgroups": 0,
    "ERROR_CODE": "TEMPORAL_TAG_ERROR",
    "subgroupTagsNotAllowed": [],
    "defTagRequired": true,
    "otherAllowedTags": []
  },
  "Delay": {
    "child": true,
    "tagGroup": true,
    "topLevelTagGroup": true,
    "maxNumberSubgroups": 1,
    "minNumberSubgroups": 1,
    "ERROR_CODE": "TEMPORAL_TAG_ERROR",
    "subgroupTagsNotAllowed": ["Event-context", "Definition", "Onset", "Inset", "Offset", "Delay", "Duration"],
    "defTagRequired": false,
    "otherAllowedTags": ["Duration"]
  },
  "Duration": {
    "child": true,
    "topLevelTagGroup": true,
    "maxNumberSubgroups": 1,
    "minNumberSubgroups": 1,
    "ERROR_CODE": "TEMPORAL_TAG_ERROR",
    "subgroupTagsNotAllowed": ["Event-context", "Definition", "Onset", "Inset", "Offset", "Delay", "Duration"],
    "defTagRequired": false,
    "otherAllowedTags": ["Delay"]
  },
  "Event-context": {
    "child": false,
    "tagGroup": true,
    "topLevelTagGroup": true,
    "maxNumberSubgroups": null,
    "minNumberSubgroups": 0,
    "ERROR_CODE": "TAG_GROUP_ERROR",
    "subgroupTagsNotAllowed": ["Event-context", "Definition", "Onset", "Inset", "Offset", "Delay", "Duration"],
    "defTagRequired": false,
    "otherAllowedTags": []
  }
}
